import { Grid, Typography } from "@mui/material";
import { withStyles, WithStyles } from "@mui/styles";
import * as coreApi from "api/Core";
import { AppImages } from "assets/appResources";
import { FeedStyleClasses, TimelineStyleClasses } from "assets/jss/common-styles";
import { RequestIndicator } from "components/CallServer";
import { RequestErrorReport } from "components/CallServer/RequestErrorReport";
import MuiContainer from "components/MuiExtras/MuiContainer";
import MuiPaper from "components/MuiExtras/MuiPaper";
import { GetGroupDto } from "models/ApiModels";
import * as React from "react";
import ReactResizeDetector from "react-resize-detector";
import { RouteComponentProps } from 'react-router';
import GroupEditMember from "views/Group/Components/GroupEditMember";

/////////////////////////////////////////////////////////////////////////////////////////////////

interface IState {
    dialog: any;
    lastError: any,
    loading: boolean;
    profile: GetGroupDto;
}

interface IProps {
}

interface IRouteParams {
    id: string;
}

type Props = IProps & RouteComponentProps<IRouteParams> & WithStyles<typeof TimelineStyleClasses>;

/////////////////////////////////////////////////////////////////////////////////////////////////

export class GroupProfileViewer extends React.Component<Props, IState> {

    constructor(props: Props) {
        super(props);

        this.state = {
            dialog: null,
            lastError: null,
            loading: true,
            profile: null
        };
    }

    ///
    private onLoad(id: string) {
        coreApi.getGroupRecord(id)
            .then((dto) => {
                this.setState({
                    profile: dto,
                    loading: false
                });
            })
            .catch((error: any) => {
                this.setState({
                    lastError: error,
                    loading: false
                });
            });
    }

    ///
    private renderContent(width: number) {
        const { classes } = this.props;
        const { profile } = this.state;

        return (
            <Grid container spacing={1} direction="row" style={{ flexWrap: "nowrap" }}>
                <Grid item style={{ flexGrow: 1 }}>

                    <div className={classes.timelineContainer}>

                        <MuiContainer margin="normal">
                            <form noValidate autoComplete="off">

                                <MuiPaper>

                                    <Grid container spacing={2}>
                                        <Grid item>
                                            <img
                                                src={
                                                    profile.thumbnail
                                                        ? profile.thumbnail.url
                                                        : AppImages.DefaultGroupThumbnail
                                                }
                                                alt={profile.name}
                                            />
                                        </Grid>

                                        <Grid item xs>

                                            <Grid container spacing={1}>

                                                <Grid item xs={12}>

                                                    <Typography variant="h5">
                                                        {profile.name}
                                                    </Typography>

                                                </Grid>

                                                <Grid item xs={12}>
                                                    <Typography variant="body2">
                                                        {profile.description}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                </MuiPaper>

                            </form>
                        </MuiContainer>

                        <MuiContainer margin="normal">

                            <GroupEditMember
                                readonly
                                groupId={profile.groupId}
                                membersChanged={[]}
                                onChange={null}
                                onEndEdit={null}
                            />

                        </MuiContainer >
                    </div>
                </Grid>
            </Grid>
        );
    }

    ///
    public componentDidMount() {
        this.onLoad(this.props.match.params.id);
    }

    ///
    public componentDidUpdate(prevProps: Props) {
        if (prevProps.match.url != this.props.match.url) {
            this.onLoad(this.props.match.params.id);
        }
    }

    ///
    public render() {
        const { loading, lastError, dialog } = this.state;

        return (
            <>
                <ReactResizeDetector handleWidth refreshMode="debounce" refreshRate={0}>
                    {
                        (d: ReactResizeDetectorDimensions) =>

                            lastError != null
                                ? <RequestErrorReport error={lastError} />
                                : loading
                                    ? <RequestIndicator type="waiting" />
                                    : this.renderContent(d.width)
                    }
                </ReactResizeDetector>

                {dialog}
            </>
        );
    }
}

/////////////////////////////////////////////////////////////////////////////////////////////////

const withAllStyles = withStyles(
    (theme) => ({
        ...TimelineStyleClasses(theme),
        ...FeedStyleClasses(theme),
    }),
    { withTheme: true },
);

export default withAllStyles(GroupProfileViewer);